import { getLanguageCode } from 'app/locales/languageMapping';
import { ar, de, el, enGB, es, fr, he, it, pl, pt, tr } from 'date-fns/locale';

export { getLanguageCode };

/** date-fns locales keyed by `languageMapping` key (resolve the code first, see Helper.getLocaleByCode). */
export const localeMap: Record<string, Locale> = { en: enGB, es, de, fr, it, pt, pl, gr: el, tr, ar, he };

export const RTL_LANGUAGES = ['ar', 'he'];

export type TextDirection = 'ltr' | 'rtl';

export const isRtlLanguage = (lng?: string | null): boolean => RTL_LANGUAGES.includes(getLanguageCode(lng));

export const getTextDirection = (lng?: string | null): TextDirection => (isRtlLanguage(lng) ? 'rtl' : 'ltr');

export const PassengerOptions = {
	adults: {
		min: 1,
		max: 9,
	},
	children: {
		min: 0,
		max: 9,
	},
};

export const VERTICAL = 'flights';

export enum TripType {
	ONE_WAY = 'one-way',
	ROUND_TRIP = 'round-trip',
}

export const DEFAULT_LOCALE = 'en-GB';

export type SelectItem = { value: string; label: string };

export const cookieCountries = [
	'BG', // Bulgaria
	'CZ', // Czech Republic
	'HU', // Hungary
	'MD', // Moldova
	'PL', // Poland
	'RO', // Romania
	'SK', // Slovakia
	'DK', // Denmark
	'EE', // Estonia
	'FI', // Finland
	'IE', // Ireland
	'LV', // Latvia
	'LT', // Lithuania
	'SE', // Sweden
	'GB', // UK (Great Britain)
	'HR', // Croatia
	'GR', // Greece
	'IT', // Italy
	'MT', // Malta
	'PT', // Portugal
	'SI', // Slovenia
	'ES', // Spain
	'AT', // Austria
	'BE', // Belgium
	'FR', // France
	'DE', // Germany
	'LU', // Luxembourg
	'NL', // Netherlands
];
